// File: client/src/variants/index.js
//
// The ONE place that wires variants into the platform. Adding a new variant means:
//   1. create client/src/variants/<id>/ (index.js module + rulebook.js [+ runtime]),
//   2. import it here and add it to the list below.
// Nothing else in the app changes — the menu, host, and rulebook all read from the
// registry.

import { registerVariant } from '../platform/variantRegistry';

import classic from './classic';
import uno from './uno';
import royale from './royale';
import zombie from './zombie';
import randomizer from './randomizer';
import power from './power';
import mayhem from './mayhem';
import party from './party';
import chaos from './chaos';

let done = false;

/** Register all built-in variants exactly once (idempotent). */
export function registerAllVariants() {
  if (done) return;
  [classic, uno, royale, zombie, randomizer, power, mayhem, party, chaos].forEach(registerVariant);
  done = true;
}

/** Test helper: force re-registration after a registry reset. */
export function __forceReregisterVariants() {
  done = false;
  registerAllVariants();
}
